$( document ).ready(function() {
     validateProductForText();
});

function setupProductRangeForm(mainSelector){
    setupUIEvents(mainSelector);
}

function setupUIEvents(mainSelector){
  $(mainSelector + " .cust-prod-selector .cust-prod-item").click(onProductItemClick);
  $(mainSelector + " .mobile-thumbs-main-container .scroll-arrow").click(onMobileArrowClick);

  $('body').on('click', mainSelector + " .variant-selector .variant-item", onVariantClick);
  $('body').on('click', mainSelector + " .mobile-thumbs-container img", onMobileImageClick);

  
  let forms = $(mainSelector).find("form[action='/cart/add']");
  forms.submit(onProductRangeFormSubmit);
}

function onProductItemClick(e){

  let selectedItem = $(this);
  let prodId = $(this).attr("data-product-id");
  let sectionId = $(this).parents("div[data-custom-prod-section-id]").attr("data-custom-prod-section-id");
  
  selectThisProduct(sectionId, prodId);
  $("div[data-custom-prod-section-id='" + sectionId + "'] .cust-prod-selector .cust-prod-item").removeClass("selected")
  $("div[data-custom-prod-section-id='" + sectionId + "'] .error-message p").text("");
  selectedItem.addClass("selected");
  validateProductForText();
}


function validateProductForText(){
  prodSel = $(".pregnancy-product-main-container .cust-product-title").text();
  debugger;
  if(prodSel.includes("Over Ankle")){
    $("span#over-ankle-text").css("display","block")
  }else{
     $("span#over-ankle-text").css("display","none")
  }
}

function onVariantClick(e){
  if($(this).hasClass("unavailable")) return;

  $(".error-message p").text("");
  $(".variant-selector .variant-item").removeClass("selected");
  $(this).addClass("selected");
}


function onMobileImageClick(e){
  let imgSrc = $(this).attr("src");
  let thumbsContainer = $(this).parents("div.mobile-thumbs-container");
  thumbsContainer.find(".custom-prod-image").removeClass("selected");
  $(this).parent().addClass("selected");
  $(".main-mobile-image img").attr("src",imgSrc);
  
}

function onMobileArrowClick(e){
  let scrollTo = $(this).hasClass("right") ? "right" : "left";
  let thumbsContainer = $(this).parent().find("div.mobile-thumbs-container");
  let scrollLeft = thumbsContainer.scrollLeft();
  if (scrollTo == "right"){
    scrollLeft += 150;
  }
  else{
    scrollLeft -= 150;
    
  }
  
  thumbsContainer.animate({
    scrollLeft: scrollLeft,
  }, 500, function() {
    // Animation complete.
  });
  
}

function selectThisProduct(sectionId, prodId){
  let currentCollection = rangeCollection[sectionId];
  let found = currentCollection.products.find(p=> p.id == prodId);

  if(!found) return;
  
  setupProductInfo(sectionId, currentCollection, found);
  setupProductImages(sectionId, currentCollection, found);
  setupProductForm(sectionId, currentCollection, found);
  setupAfterpay(sectionId,currentCollection, found);
}

// function setupAfterpay(sectionId,currentCollection, found){ // Old buggy afterpay implementation 
//    const sectionSelector = `div[data-custom-prod-section-id='${sectionId}'] .product-form--container`;
//   $("div[data-custom-prod-section-id='" + sectionId + "'] .product-form--container square-placement").remove();
//   afterpay_product = found;
//   let variant = found.variants.find(v=>v.available);
//   if(variant == undefined) variant = found.variants[0];
//   afterpay_current_variant = variant;
//   if(overwriteAfterPay == true){
//     Afterpay.initProductPage($);
//     return;
//   }
//     // Check if Afterpay is already initialized for this section
//   const afterpayInitialized = $(`${sectionSelector} .afterpay-button`).length > 0;
//   if (afterpayInitialized) {
//     console.log("Afterpay already initialized for this section. Skipping...");
//     return;
//   }

//   Afterpay.init($);
// }
function setupAfterpay(sectionId, currentCollection, found) {
  // Check and remove any existing <square-placement> elements
  const afterpayElements = $("square-placement");
  if (afterpayElements.length > 0) {
    // console.log(`Removing ${afterpayElements.length} existing Afterpay element(s)...`);
    afterpayElements.remove();
  }

  afterpay_product = found;

  // Select the first available variant or fallback to the first variant
  let variant = found.variants.find(v => v.available);
  if (!variant) variant = found.variants[0];

  afterpay_current_variant = variant;

  // Initialize Afterpay
  if (overwriteAfterPay === true) {
    // console.log("Initializing Afterpay Product Page...");
    Afterpay.initProductPage($);
  } else {
    // console.log("Initializing Afterpay...");
    Afterpay.init($);
  }
}

function setupProductInfo(sectionId, currentCollection, product){
  //TODO Title
  $("div[data-custom-prod-section-id='" + sectionId + "'] .cust-product-title h2").text(product.title);
  //TODO Description
  //$("div[data-custom-prod-section-id='" + sectionId + "'] .collapsible-container.description .collapsible-content").html(product.description);
  //TODO Prices
  $("div[data-custom-prod-section-id='" + sectionId + "'] .cust-prod-price p").text(theme.utils.formatMoney(product.price));
  
  //TODO Variants
  let productVariantsHtml = "";
  let foundAvailable = false;
  for(let v = 0; v < product.variants.length; v++){
    let variant = product.variants[v];
    let selectedClass = "";
    let variantTitle = variant.title.toUpperCase().replace("/ BLACK","");
    //v == 0 ? "selected" : "";
    let availableClass = "";
    let checked = "";
    let disabled = "";
    if(variant.available == false){
      availableClass =  "unavailable";
      selectedClass = "";
      disabled = "disabled";
    }
    else{
      if(!foundAvailable){
        foundAvailable = true;
        selectedClass = "selected";
        checked = "checked";
      }
    }
    productVariantsHtml += `<div class="variant-item ${availableClass} ${selectedClass}">
              <label for="variant${variant.id}">
                <span>${variantTitle}</span>
              </label>
              <input type="radio" name="id" id="variant${ variant.id }" value="${variant.id}" class="product-variant-radio" ${disabled} ${checked} />
            </div>`;
  }
  $("div[data-custom-prod-section-id='" + sectionId + "'] .variant-selector").html(productVariantsHtml);
}
function setupProductImages(sectionId, currentCollection, product){
  //TODO desktops images
  //TODO mobile images
  let prodImagesHtml = "";
  let length = product.images.length > 6 ? 6 : product.images.length;
  let firstImg = "";
  for(let im = 0; im < length; im++){
    let img = product.images[im];
    let selected = "";
    if(im == 0){
      selected = "selected";
    }
    let imgHtml = `<div class="custom-prod-image ${selected}">
      <img src="${img}" width="auto" height="auto" loading="eager" />
    </div>`;
    if(im == 0){
      firstImg = imgHtml;
    }
    prodImagesHtml += imgHtml;
  }
  $("div[data-custom-prod-section-id='" + sectionId + "'] .custom-prod-images-container").html(prodImagesHtml);
  $("div[data-custom-prod-section-id='" + sectionId + "'] .mobile-thumbs-container").html(prodImagesHtml);
  $("div[data-custom-prod-section-id='" + sectionId + "'] .main-mobile-image").html(firstImg);
}
function setupProductForm(sectionId, currentCollection, product){
  //TODO Default variant id
}

function onProductRangeFormSubmit(e){
  let thisForm = $(this);
  /*let idToAdd = thisForm.find("[name='id']").val();
  let quantityToAdd = thisForm.find("[name='quantity']").val();*/
  let buttonContainer = $(this).find(".add-to-cart-button-container.product-form--button-container");
  buttonContainer.attr("data-loading","true");
  /*let data = {
    items: [
      {id: idToAdd, quantity: quantityToAdd}
    ]
  };*/
  console.log()
  theme.partials.Cart.addItem(thisForm,function(allOk, message){
    if(allOk == false){
      //debugger;
      let messageParagraph = thisForm.find(".error-message p");
      messageParagraph.text("Product currently not available.");
      buttonContainer.attr("data-loading","false");
      return;
    }
    theme.partials.Cart.updateAllHtml(function() {
      //debugger;
      buttonContainer.attr("data-loading","false");
      $('[data-off-canvas--open="right-sidebar"]').first().trigger('click');
    });
  });
  
  e.preventDefault();
  return false;
}
